//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IUnisonTheme } from '@bvengineering/unison-core';
import React from 'react';
import styled, { css } from 'styled-components';
import { Icon } from 'unison';

interface IOwnProps extends React.HTMLAttributes<HTMLDivElement> {
  sectionTitles: string[];
  currentIndex: number;
}

export const WorkflowBreadcrumbs: React.FunctionComponent<IOwnProps> = ({
  sectionTitles,
  currentIndex,
  className,
}) => {
  const lastIndex = sectionTitles.length - 1;

  return (
    <div className={className}>
      {sectionTitles.map((sectionTitle, index) => {
        return (
          <div className='cu-d-inline-block' key={index}>
            {index < currentIndex && (
              <StyledCheckmark name='circle-checkmark-filled' />
            )}
            <SectionTitle
              className='cu-text-meta-tag'
              isActive={currentIndex === index}
            >
              {sectionTitle}
            </SectionTitle>
            {index < lastIndex && <StyledChevron name='chevron-right' />}
          </div>
        );
      })}
    </div>
  );
};

const toggleActive = (isActive: boolean, theme: IUnisonTheme) => {
  if (isActive) {
    return css`
      color: ${theme.colors.aliases.primary};
    `;
  } else {
    return css`
      opacity: 0.5;
    `;
  }
};

const StyledCheckmark = styled(Icon)`
  margin-right: ${({ theme }) => theme.spacings[2]};
  color: ${({ theme }) => theme.colors.green7};
`;

const StyledChevron = styled(Icon)`
  margin-right: ${({ theme }) => theme.spacings[3]};
  opacity: 0.3;
`;

interface ISectionTitle {
  isActive: boolean;
}

const SectionTitle = styled.span<ISectionTitle>`
  && {
    display: inline-block;
    ${({ theme, isActive }) => toggleActive(isActive, theme)}
    margin-right: ${({ theme }) => theme.spacings[3]};
  }
`;
